var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCutBox = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 23,
  fill: "none",
  viewBox: "0 0 24 23",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#28A4DD",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.447.014H5.127A4.757 4.757 0 0 0 .372 4.77a2.854 2.854 0 0 0 2.854 2.854H20.35a2.826 2.826 0 0 0 2.854-2.642 4.76 4.76 0 0 0-4.757-4.97M21.301 9.528H2.273a.95.95 0 0 0-.951.951v7.611a4.763 4.763 0 0 0 4.757 4.757h11.417a4.763 4.763 0 0 0 4.757-4.757v-7.61a.95.95 0 0 0-.952-.952m-6.66 4.757H8.934a.951.951 0 1 1 0-1.903h5.709a.952.952 0 0 1 0 1.903"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.37.014h22.835v22.834H.37z"
})))));
export { SvgCutBox as ReactComponent };
export default __webpack_public_path__ + "assets/images/cutBox.svg";